import SvgColor from "../../../components/svg-color";
import Iconify from "../../../components/iconify";

// ----------------------------------------------------------------------

const icon = (name: any) => (
  <SvgColor
    src={`/assets/icons/navbar/${name}.svg`}
    sx={{ width: 1, height: 1 }}
  />
);

export const navConfig = [
  {
    title: "Dashboard ",
    path: "/dashboard/sales-report",
    icon: <Iconify icon="icon-park-outline:sales-report" />,
  },
  {
    title: "Add / Edit event",
    path: "/dashboard/events",
    icon: <Iconify icon="carbon:event" />,
  },
  {
    title: "Add / Edit Coupon",
    path: "/dashboard/coupons",
    icon: <Iconify icon="tdesign:coupon" />,
  },
  {
    title: "Issue Free Tickets",
    path: "/dashboard/book-ticket",
    icon: <Iconify icon="fluent-emoji-high-contrast:free-button" />,
  },
  {
    title: "View Order",
    path: "/dashboard/orders",
    icon: <Iconify icon="material-symbols:order-approve-outline" />,
  },
  {
    title: "Profile & Bank",
    path: "/dashboard/profile",
    icon: <Iconify icon="healthicons:ui-user-profile" />,
  },
];

export const navConfigAdmin = [
  {
    title: "Dashboard",
    path: "/dashboard/sales-report",
    icon: <Iconify icon="icon-park-outline:sales-report" />,
  },
  {
    title: "Add / Edit event",
    path: "/dashboard/events",
    icon: <Iconify icon="carbon:event" />,
  },
  {
    title: "Add / Edit Coupon",
    path: "/dashboard/coupons",
    icon: <Iconify icon="tdesign:coupon" />,
  },
  {
    title: "Issue Free Tickets",
    path: "/dashboard/book-ticket",
    icon: <Iconify icon="fluent-emoji-high-contrast:free-button" />,
  },
  {
    title: "View Order",
    path: "/dashboard/orders",
    icon: <Iconify icon="material-symbols:order-approve-outline" />,
  },
  {
    title: "Service Fees",
    path: "/dashboard/service-fee",
    icon: <Iconify icon="solar:hand-money-linear" />,
  },
  {
    title: "Profile & Bank",
    path: "/dashboard/profile",
    icon: <Iconify icon="healthicons:ui-user-profile" />,
  },
];
